import React, { forwardRef } from "react";
import MaterialIcon from "../../BuilderComponents/MaterialIcon";

const ACTIVITY_COLORS = {
  pre: "#34CA52",
  pre_submission: "#649CF5",
  post: "#F59B28",
  activity: "#F85A78",
  state: "#A259FF"
};

const GroupNodeLabel = forwardRef(({ label, type, position = "top-left", isCircle = false }, ref) => {
  const getLabelStyle = () => {
    const baseStyle = {
      position: "absolute",
      background: "white",
      color: "#1e293b",
      padding: "8px 12px",
      fontSize: "14px",
      fontWeight: "400",
      borderRadius: "4px",
      boxShadow: "8px 8px 24px 3px #D7D7D7",
      // filter: "drop-shadow(rgba(0, 0, 0, 0.4) 3px 5px 5px)",
      zIndex: 10,
      whiteSpace: "nowrap",
      border: "1px solid #e2e8f0",
      display: "flex",
      alignItems: "center",
      gap: ".25rem"
    };

    if (isCircle) {
      return {
        ...baseStyle,
        top: "0px",
        right: "100%",
        textAlign: "center"
      };
    }

    switch (position) {
      case "top-left":
        return { ...baseStyle, top: "-28px", left: "10px" };
      case "top-center":
        return { ...baseStyle, top: "-28px", left: "50%", transform: "translateX(-50%)" };
      case "top-right":
        return { ...baseStyle, top: "-28px", right: "10px" };
      case "bottom-left":
        return { ...baseStyle, bottom: "-28px", left: "10px" };
      case "bottom-center":
        return { ...baseStyle, bottom: "-28px", left: "50%", transform: "translateX(-50%)" };
      case "bottom-right":
        return { ...baseStyle, bottom: "-28px", right: "10px" };
      default:
        return baseStyle;
    }
  };

  return (
    <div ref={ref} style={getLabelStyle()}>
      {isCircle ? (
        <div
          style={{
            width: "28px",
            height: "28px",
            border: "1px solid rgb(203, 213, 225)",
            borderRadius: "4px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginRight: "4px",
            backgroundColor: ACTIVITY_COLORS[type]
          }}
        >
          <MaterialIcon
            name="add"
            style={{
              color: "white",
              fontSize: "20px"
            }}
          />
        </div>
      ) : (
        <MaterialIcon
          name="account_tree"
          style={{
            fontSize: "28px",
            padding: "4px",
            marginRight: "4px",
            color: "#64748b"
          }}
        />
      )}
      {label}
    </div>
  );
});

export default GroupNodeLabel;
